import React from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from '@mui/material';

export default function RouteInitializationPage({ displayName, error = null }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'background.default',
        p: 3,
      }}
    >
      <Paper elevation={3} sx={{ width: 'min(520px, 100%)', p: 4, textAlign: 'center' }}>
        {error ? (
          <>
            <Alert severity="error" sx={{ textAlign: 'left', mb: 3 }}>
              <AlertTitle>Unable to select a documentation version</AlertTitle>
              {error.message}
            </Alert>
            <Button variant="contained" onClick={() => window.location.reload()}>
              Retry
            </Button>
          </>
        ) : (
          <>
            <CircularProgress />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Opening {displayName}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Loading available documentation versions…
            </Typography>
          </>
        )}
      </Paper>
    </Box>
  );
}
